import Vue from 'vue';
import Blog from './../vue/Blog/Blog.vue';
import MazeThemes from './../vue/MazeThemes/MazeThemes.vue';
import InfiniteLoading from 'vue-infinite-loading';

export default {

  init() {

    if ( document.querySelector( '.js-archive-container' ) == null ) {
      return;
    }

    this.els = {
      'blog': {
        el: '#blog',
        components: {
          Blog,
        },
        render: h => h( Blog ),
        template: "<post-list />",
      },
      'maze-themes': {
        el: '#maze-themes',
        components: {
          MazeThemes,
        },
        render: h => h( MazeThemes ),
        template: "<post-list />",
      },
    }

    this.onReady = this.onReady.bind( this );

    this.onReady();

  },

  onReady() {
    console.log('archive:DOMContentLoaded');

    this.loadArchive();

  },

  loadArchive() {

    Object.keys( this.els ).map( id => {

      if ( document.getElementById( id ) != null ) {
        new Vue( this.els[ id ] );

        if ( document.querySelector( '.js-load-more-pagination' ) != null ) {
          Vue.use( InfiniteLoading );
        }
      }

    });

  },

}




// import Vue from 'vue/dist/vue.min.js';
// // import Paginate from 'vuejs-paginate';
// // import images from './images.js';
// // import animation from './animation.js';
// // import scroll from './scroll.js';
// import InfiniteLoading from 'vue-infinite-loading';

// export default {
//   init() {

//     if ( document.querySelector( '.js-archive-container' ) == null ) {
//       return;
//     }

//     this.onReady = this.onReady.bind( this );
//     // this.buildPosts = this.buildPosts.bind( this );
//     // this.buildTerms = this.buildTerms.bind( this );
//     // this.filterPosts = this.filterPosts.bind( this );

//     wp.api.loadPromise.done( () => {
//       this.onReady();
//     })

//   },

//   onReady() {

//     const filters = {
//       'blog': {
//       },
//     };

//     const defaultData = {
//       posts: [],
//       filters: {
//         categories: {
//           terms: [],
//           current: [],
//         },
//       },
//       latest: false,
//       searching: false,
//       noResults: false,
//       loadmore: false,
//       distance: -Infinity,
//       reset: false,
//       page: 1,
//       hasPagination: false,
//       pagination: false,
//       isLoadingNextPage: false,
//     };

//     Object.keys( filters ).map( ( el ) => {

//       if ( document.getElementById( el ) != null ) {

//         const filterData = filters[ el ];
//         const newFilterData = Object.assign( filterData, defaultData );
//         this.filterPosts( el, newFilterData );

//       }

//     });

//   },

//   filterPosts( target, filterData ) {

//     if ( document.querySelector( '.js-load-more-pagination' ) != null ) {
//       Vue.use( InfiniteLoading );
//     }

//     new Vue({
//       el: '#' + target,
//       components: {
//         InfiniteLoading,
//       },
//       data: filterData,
//       mounted() {

//         wp.api.loadPromise.done( () => {
//           this.loadArchive();
//         });

//       },
//       watch: {

//         categories: 'buildPosts',

//       },
//       methods: {

//         loadArchive() {

//           const postData = {};
//           const termData = {};

//           this.buildPosts( postData );
//           this.buildTerms( termData );

//         },
//         filter() {

//           this.searching = true;

//           this.page = 1;
//           this.posts = [];
//           this.infiniteId += 1;

//           const currentFilters = this.filters.categories.current;
//           const postData = {
//             filters: {
//               'category': currentFilters,
//             },
//           };

//           $( '.js-filter-item' ).removeClass( 'is-active' );

//           Object.keys( currentFilters ).map( index => {
//             document.querySelector( '.js-filter-item[for="' + currentFilters[ index ] + '"]' ).classList.add( 'is-active' );
//           });

//           this.buildPosts( postData );

//         },
//         loadMoreTrigger() {

//           this.isLoadingNextPage = true;

//           this.distance = 100;
//           this.$nextTick(() => {
//             this.$refs.infiniteLoading.attemptLoad();
//           });

//         },
//         loadMoreHandler( $state ) {

//           if ( this.distance < 0 || this.distance != parseInt( this.distance, 10 ) ) {
//             return;
//           }

//           const data = {};
//           data.page = this.page + 1;
//           data.paged = this.page + 1;

//           const allPosts = new wp.api.collections.Posts();

//           allPosts.fetch({ data }).done( ( results ) => {

//             this.pagination = results.pagination;

//             if ( results.results && results.results.length ) {
//               this.page += 1;
//               this.posts.push( ...results.results );

//               if ( this.page >= results.pagination.query.total ) {
//                 this.pagination = false;
//                 this.hasPagination = false;
//               } else {
//                 this.hasPagination = true;
//               }

//               $state.loaded();
//               this.distance = -Infinity;
//               this.isLoadingNextPage = false;

//             } else {

//               $state.complete();

//             }

//           });

//         },
//         buildPosts( data ) {

//           const allPosts = new wp.api.collections.Posts();

//           allPosts.fetch({ data }).done( ( results ) => {

//             // console.log( results );
//             this.searching = false;
//             this.title = results.title;

//             if ( !results ) {
//               this.noResults = results.no_results;
//               return;
//             }

//             if ( ( typeof results.results == 'undefined' || Object.keys( results.results ).size == 0 ) ) {
//               this.noResults = results.no_results;
//               this.hasPagination = false;
//               return;
//             } else {
//               this.noResults = false;
//             }

//             if ( results.pagination.query.total > 1 ) {
//               this.hasPagination = true;
//             }

//             this.latest = results.latest;
//             this.posts = results.results;
//             this.pagination = results.pagination;

//             // setTimeout( () => {
//             //   Images.lazyload.update();
//             // }, 200)

//           })

//         },
//         buildTerms( data ) {

//           const allTerms = new wp.api.collections.Categories();

//           allTerms.fetch({ data }).done( ( results ) => {
//             this.filters.categories.terms = results;
//           });

//         },
//       },
//     });

//   },

//   // scrollToTopArchive( target ) {

//   //   const anchor = document.querySelector( target );
//   //   scroll.thisSmoothScroll.animateScroll( anchor );

//   // },

//   // setFilterFields( filters, target ) {

//   //   let isFiltered = false;

//   //   Object.keys( filters ).map( ( index ) => {
//   //     const terms = filters[ index ];

//   //     Object.keys( terms ).map( ( termindex ) => {
//   //       const term = terms[ termindex ];

//   //       if ( term != '' ) {
//   //         const termField = document.getElementById( target ).querySelector( 'input#' + term );

//   //         if ( termField != null ) {
//   //           termField.parentElement.classList.add( 'is-active' );
//   //           termField.setAttribute( 'selected', 'selected' );
//   //           isFiltered = true;

//   //           document.getElementById( target ).querySelector( '.js-clear-filter' ).style.display = 'block';
//   //         }
//   //       }

//   //     })
//   //   });

//   //   if ( !isFiltered ) {
//   //     const termField = document.getElementById( target ).querySelector( 'input#all' );

//   //     if ( termField != null ) {
//   //       termField.parentElement.classList.add( 'is-active' );
//   //       termField.setAttribute( 'selected', 'selected' );
//   //     }
//   //   }

//   // },

//   // buildPosts( data ) {

//   //   const allPosts = new wp.api.collections.Posts();

//   //   allPosts.fetch({ data }).done( ( results ) => {

//   //     console.log( results );
//   //     this.searching = false;
//   //     this.title = results.title;

//   //     if ( !results ) {
//   //       this.noResults = results.no_results;
//   //       return;
//   //     }

//   //     if ( ( typeof results.results == 'undefined' || Object.keys( results.results ).size == 0 ) ) {
//   //       this.noResults = results.no_results;
//   //       this.hasPagination = false;
//   //       return;
//   //     } else {
//   //       this.noResults = false;
//   //     }

//   //     if ( results.pagination.query.total > 1 ) {
//   //       this.hasPagination = true;
//   //     }

//   //     this.posts = results.results;
//   //     this.pagination = results.pagination;

//   //     // setTimeout( () => {
//   //     //   Images.lazyload.update();
//   //     // }, 200)

//   //   })

//   // },
//   // buildTerms( data ) {

//   //   const allTerms = new wp.api.collections.Categories();

//   //   allTerms.fetch({ data }).done( ( results ) => {
//   //     this.filters.categories.terms = results;
//   //   });

//   // },

//   // // getPosts( allPosts, data, self ) {

//   // //   setTimeout( () => {

//   // //     allPosts.fetch({ data }).done( ( results ) => {

//   // //       console.log( results );
//   // //       if ( !results ) {
//   // //         self.noResults = true;
//   // //         self.searching = false;
//   // //         return;
//   // //       }

//   // //       if ( ( typeof results.results == 'undefined' || Object.keys( results.results ).size == 0 ) ) {
//   // //         self.noResults = true;
//   // //       } else {
//   // //         self.noResults = false;
//   // //       }

//   // //       if ( typeof results.pinned != 'undefined' ) {
//   // //         self.pinned = results.pinned;

//   // //         if ( self.pinned.size == 0 && ( typeof results.results == 'undefined' || Object.keys( results.results ).size == 0 ) ) {
//   // //           self.noResults = true;
//   // //         } else {
//   // //           self.noResults = false;
//   // //         }
//   // //       }

//   // //       if ( typeof results.pagination != 'undefined' ) {
//   // //         if ( results.pagination.total > 1 ) {
//   // //           self.pagination = true;
//   // //         }
//   // //       }

//   // //       self.init = false;
//   // //       self.searching = false;
//   // //       self.results = results.results;

//   // //     });

//   // //   }, 1000 );
//   // },
// }



// WEBPACK FOOTER //
// ./scripts/modules/archive.js